import { Component, Vue, Prop } from 'vue-property-decorator'
import { Structure, FormatCurrency } from '@/common/helpers/structure.helper'
import ApplicationData from '@/common/service/application-data.service'

@Component({})
export class ListItems extends Vue {

    public helper          = new Structure();
    public helperFormat    = new FormatCurrency();
    public checkClientType: boolean = false;

    
    @Prop({})
    public slug?: string;

    @Prop({})
    public data?: any;

    created(){

        this.checkClientType = !!this.data.items;

        if( this.checkClientType ){
            this.orderShowcase(this.data.items);
        }
    }

    public orderShowcase(val: any){
        this.data.items = val.sort((a: any, b: any) => {
            return a.order - b.order;
        })
    }

    public expiredItem(date: Date|any){
        if( date ){
            const currentDate   = new Date().getTime();
            const futureDate    = new Date(date).getTime();

            return currentDate <= futureDate;
        }else{
            return true;
        }
    }

    public produtoDetalhe(prod: any){
        ApplicationData.setClientData(this.data);
        this.$emit('modalProdutoDetalhe', prod);
    }

}